import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft, Mail, ExternalLink, Trash2 } from "lucide-react";

export default function OpportunityApplicants() {
  const { opp_id } = useParams();
  const [opp, setOpp] = useState(null);
  const [apps, setApps] = useState([]);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get(`/opportunities/${opp_id}`); setOpp(data); } catch {}
      try { const { data } = await api.get(`/opportunities/${opp_id}/applications`); setApps(data); } catch {}
    })();
  }, [opp_id]);

  const remove = async () => {
    if (!confirm("Delete this opportunity?")) return;
    await api.delete(`/opportunities/${opp_id}`);
    window.location.href = "/dashboard/vendor";
  };

  if (!opp) return <Layout><div className="max-w-3xl mx-auto px-6 py-24 text-muted">Loading…</div></Layout>;

  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-6 md:px-10 py-12 md:py-16">
        <Link to="/dashboard/vendor" className="inline-flex items-center gap-2 text-muted hover:text-ink mb-6 text-sm">
          <ArrowLeft className="w-4 h-4" strokeWidth={1.5}/> Back
        </Link>

        <div className="qld-card p-8 mb-8">
          <p className="qld-overline mb-2">{opp.type}</p>
          <h1 className="font-serif text-4xl text-ink mb-3">{opp.title}</h1>
          <p className="text-ink/85 whitespace-pre-wrap">{opp.description}</p>
          <button onClick={remove} data-testid="opp-delete-btn"
            className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full border-2 border-black bg-linen text-wine hover:bg-wine hover:text-white transition-all text-sm font-medium">
            <Trash2 className="w-4 h-4" strokeWidth={1.5}/> Delete opportunity
          </button>
        </div>

        <h2 className="font-serif text-2xl text-ink mb-4">Applicants ({apps.length})</h2>
        {apps.length === 0 ? (
          <div className="qld-card p-8 text-center text-muted">No applications yet.</div>
        ) : (
          <ul className="space-y-3" data-testid="applicants-list">
            {apps.map((a) => (
              <li key={a.app_id} className="qld-card p-5 flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div>
                  <p className="font-serif text-xl text-ink">{a.lover_name}</p>
                  <p className="text-sm text-muted">{a.lover_email}</p>
                  {a.message && <p className="text-sm text-ink/85 mt-2 italic">"{a.message}"</p>}
                </div>
                <div className="flex items-center gap-2 flex-wrap">
                  <Link to={`/lovers/${a.lover_id}`} className="qld-btn-ghost !px-4 !py-2 text-sm">
                    <ExternalLink className="w-3.5 h-3.5" strokeWidth={1.5}/> View profile
                  </Link>
                  <a href={`mailto:${a.lover_email}?subject=${encodeURIComponent("Re: " + opp.title)}`} className="qld-btn-primary !px-4 !py-2 text-sm">
                    <Mail className="w-3.5 h-3.5" strokeWidth={1.5}/> Email
                  </a>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Layout>
  );
}
